:host {
  display: block;
  position: relative;
}

.main-nav {
  width: 100%;

  &.is-mobile {
    z-index: -1;
    position: fixed;
    top: var(--header-height);
    left: 0;
    right: 0;
    bottom: 0;
    background: $color-white;
    display: flex;
    flex-direction: column;
    visibility: hidden;
    translate: 0 -100%;

    interpolate-size: allow-keywords;
    transition:
      visibility 0.3s ease,
      translate 0.3s ease;

    &.is-open {
      translate: 0 0;
      opacity: 1;
      visibility: visible;
    }
  }
}

.main-nav-content {
  border-top: 1px solid $color-grey-01;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - var(--header-height));
  padding: 32px 24px 48px;

  @include media-max(xl) {
    overflow-y: scroll;
  }

  @include media-min(xl) {
    border-top: none;
    display: block;
    height: auto;
    padding: 0;
  }

  .main-nav-content-wrapper {
    padding-top: 56px;
    display: grid;
    row-gap: 12px;

    .overflow-nav-btn {
      display: none;
    }

    @include media-min(xl) {
      padding: 0 32px;
      row-gap: unset;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      column-gap: 4px;

      > dc-ui-button {
        display: none;
      }

      &.overflow {
        display: grid;
        grid-template-columns: auto auto auto;

        > dc-ui-button {
          display: block;
        }
      }

      .main-nav-content-wrapper-inner {
        padding: 0;
        row-gap: unset;
        display: flex;
        flex-direction: row;
        justify-content: center;
        column-gap: 4px;

        &.overflow {
          overflow-x: auto;
          justify-content: flex-start;
          scrollbar-width: none;
          -ms-overflow-style: none;
          &::-webkit-scrollbar {
            display: none;
          }
        }
      }
    }

    @include media-max(xl) {
      .main-nav-content-wrapper-inner {
        display: grid;
        grid-template-columns: 1fr;
        gap: 12px;
      }
    }
  }

  .meta-nav-wrapper {
    display: grid;
    gap: 10px;
    padding-top: 32px;
    border-top: 1px solid $color-grey-03;
  }
}
